import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import store from './store'
import './permission'
import './plugins/storage'
import router from './router'
import './plugins/vant.js'
import CTComponents from '@/components/common'
import {getAndroidToken} from '@/utils/token.js'
import {delAndroidToken} from '@/utils/token.js'
import plugins from './plugins' // plugins
import {mixin} from '@/mixin/index.js'
import "@/router/UstomsInspection/beforeResolve"
import { Lazyload } from 'vant';

// import vconsole from 'vconsole'
// const vConsole = new vconsole()
// Vue.prototype.$vconsole = vConsole
//判断是ios还是安卓
navigator.__proto__.isAndroid = function() {
  return this.userAgent.toLowerCase().indexOf("android") > -1;
};

navigator.__proto__.isIOS = function() {
  return this.userAgent.toLowerCase().indexOf("iphone") > -1 ||
         this.userAgent.toLowerCase().indexOf("ipad") > -1 ||
         this.userAgent.toLowerCase().indexOf("ipod") > -1;
};
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.mixin(mixin);
Vue.use(plugins)
import vueEsign from 'vue-esign'  //手写签名
Vue.use(vueEsign)
window.getAndroidToken =  getAndroidToken
window.delAndroidToken =  delAndroidToken
import { Toast } from 'vant';
Toast.setDefaultOptions({closeOnClick:true});


// 注册自定义组件
CTComponents()
// 关闭Vue的生产提示
Vue.config.productionTip = false

// 关闭错误处理的全屏覆盖
Vue.config.errorHandler = function (err, vm, info) {
  // 只在控制台打印错误，不显示全屏覆盖
  console.error('Vue Error:', err)
  console.error('Component:', vm)
  console.error('Info:', info)
}

// 关闭警告处理的全屏覆盖
Vue.config.warnHandler = function (msg, vm, trace) {
  console.warn('Vue Warning:', msg)
  console.warn('Component:', vm)
  console.warn('Trace:', trace)
}

new Vue({
  store,
  router,
  render: h => h(App),
  beforeCreate(){
    Vue.prototype.$bus = this
  }
}).$mount('#app')


